var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { flow } from "mobx";
import { keepTruthy } from "./array.utils";
import { copyWithJSON } from "./objects.utils";
import { isArray, isFunction } from "./typeChecks.utils";
export var stringifyDateRangeFilterArrayIndexForm = function (filterName, object) {
    var _a;
    var filterArr = keepTruthy([
        object.key,
        (_a = object.startDate) !== null && _a !== void 0 ? _a : "0000-01-01",
        object.endDate,
    ]);
    return object.key === null
        ? ""
        : object.shouldFilterUseArrayIndexForm
            ? filterArr.reduce(function (prev, curr, index) {
                return prev.concat((index !== 0 ? "&" : "") + "filter[" + filterName + "][" + index + "]=" + curr);
            }, "")
            : filterArr.join(",");
};
export var stringifyDateRangeFilter = function (object) {
    var _a;
    return object.key === null ? "" : keepTruthy([
        object.key,
        (_a = object.startDate) !== null && _a !== void 0 ? _a : '0000-01-01',
        object.endDate
    ]).join(',');
};
export var stringifyDateRangeFilterCommaDelimited = stringifyDateRangeFilter;
export function makeLaravelIndexDataFetcher(API, modelName, urlFactory, paramsFactory, options) {
    return function (state) { return new Promise(flow(function (resolve, reject) {
        var params, isInfinity, stringifiedParamSet, sortOptions, url, _a, entries, response, result, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    params = (isFunction(paramsFactory) ? paramsFactory() : copyWithJSON(paramsFactory)) || {};
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    isInfinity = params.perPage === -1 || params.perPage === Infinity;
                    if (state.searchQuery) {
                        if (state.searchByKeyName && state.searchQuery) {
                            if (!params.filter)
                                params.filter = {};
                            params.filter[state.searchByKeyName] = state.searchQuery;
                        }
                    }
                    stringifiedParamSet = __assign(__assign({}, params), { page: isInfinity ? 1 : state.paginationState.currentPage, perPage: isInfinity ? params.perPage : state.paginationState.perPage, filter: isArray(params.filter) ? "[" + params.filter.join(',') + "]" : params.filter });
                    sortOptions = state.sortByKeyName ? "" + (state.sortDirection === 'desc' ? '-' : '') + state.sortByKeyName : '';
                    if (sortOptions) {
                        stringifiedParamSet['sort'] = sortOptions;
                    }
                    url = urlFactory(stringifiedParamSet);
                    return [4 /*yield*/, API.getMany(url)];
                case 2:
                    _a = (_b.sent()), entries = _a.entries, response = _a.response;
                    state.paginationState.currentPage = response.data.current_page;
                    state.paginationState.totalItems = response.data.total;
                    state.paginationState.perPage = response.data.per_page;
                    (options === null || options === void 0 ? void 0 : options.onSuccess) && options.onSuccess(entries);
                    result = entries;
                    if (options === null || options === void 0 ? void 0 : options.localFilter)
                        result = result.filter(options.localFilter);
                    resolve(result);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    (options === null || options === void 0 ? void 0 : options.onError) && options.onError(e_1);
                    reject(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    })); };
}
